import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import SEO from '../components/SEO';
import Header from '../components/Header';
import { AboutHero, AboutContent, TeamSection } from '../components/AboutPageSections';
import WhyChooseUs from '../components/WhyChooseUs';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white text-securelec-dark">
      <SEO 
        title="About Us - Local Electricians Bayside Melbourne"
        description="Meet the team behind Securelec. Licensed electricians and security experts serving Carrum, Bayside and South East Melbourne since 2025."
        keywords="about Securelec, electrician Bayside Melbourne, local electrician Carrum, security installer Melbourne, licensed electrical contractor"
        canonical="https://securelec.net.au/about-us"
      />
      <Header />
      <main>
        <AboutHero />
        <AboutContent />
        <WhyChooseUs />
        <TeamSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
